"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var Dropdown = /** @class */ (function (_super) {
    tslib_1.__extends(Dropdown, _super);
    function Dropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dropdown.prototype.renderSection = function (section, sectionIdx) {
        var _this = this;
        return (React.createElement("div", { key: sectionIdx, className: "site-search__dropdown__section" },
            this.renderSectionHeading(section),
            section.results.map(function (r, idx) { return _this.renderSectionItem(r, idx); })));
    };
    Dropdown.prototype.renderSectionHeading = function (section) {
        if (!section.heading) {
            return false;
        }
        if (!section.results.length) {
            return false;
        }
        return (React.createElement("div", { className: "site-search__dropdown__section__heading" }, section.heading));
    };
    Dropdown.prototype.renderSectionItem = function (suggestion, idx) {
        var isActive = suggestion.positionEqual(this.props.selectedSuggestion);
        return (React.createElement(suggestion.component, { key: idx, suggestion: suggestion, active: isActive, lastTypedValue: this.props.lastTypedValue, selectSuggestion: this.props.selectSuggestion }));
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "site-search__dropdown" }, this.props.suggestions.map(function (s, idx) { return _this.renderSection(s, idx); })));
    };
    return Dropdown;
}(React.Component));
exports.Dropdown = Dropdown;
exports.default = user_context_provider_1.withUserContext(Dropdown);
//# sourceMappingURL=dropdown.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/dropdown.js
// module id = l97K
// module chunks = 20 21